import request from './interceptor'
import { mockLoginResponse, mockRefreshTokenResponse, mockRequestDelay, mockUpdatePasswordResponse } from '../utils/mock'

// 是否使用mock数据，开发环境下默认使用
const USE_MOCK = false;

// 登录接口
export function login(data) {
  if (USE_MOCK) {
    // 使用mock数据
    return new Promise((resolve) => {
      // 模拟网络延迟
      mockRequestDelay().then(() => {
        // 验证用户名和密码（这里简单验证，实际项目中应该由后端验证）
        if (data.username === 'admin' && (data.password === 'admin' || data.password === 'admin')) {
          resolve(mockLoginResponse)
        } else {
          resolve({
            code: 401,
            message: '用户名或密码错误'
          })
        }
      })
    })
  } else {
    // 实际请求后端API
    return request({
      url: '/v1/auth/login',
      method: 'post',
      data
    })
  }
}

// 获取七牛和萤石云token
export function getToken() {
  // 实际请求后端API
  return request({
    url: '/v1/token',
    method: 'get'
  })
}

// 刷新token接口
export function refreshToken(data) {
  if (USE_MOCK) {
    // 使用mock数据
    return new Promise((resolve) => {
      // 模拟网络延迟
      mockRequestDelay().then(() => {
        // 简单验证RefreshToken是否存在
        if (data.RefreshToken) {
          resolve(mockRefreshTokenResponse)
        } else {
          resolve({
            code: 401,
            message: 'RefreshToken无效'
          })
        }
      })
    })
  } else {
    // 实际请求后端API
    // 后端需要RefreshToken作为参数名
    return request({
      url: '/v1/auth/refresh',
      method: 'post',
      data
    })
  }
}

// 更新密码接口
export function updatePassword(data) {
  console.log('updatePassword函数被调用，数据:', data)
  console.log('USE_MOCK:', USE_MOCK)
  console.log('request对象:', request)
  
  if (USE_MOCK) {
    // 使用mock数据
    console.log('使用mock数据，不发送实际请求')
    return new Promise((resolve) => {
      // 模拟网络延迟
      mockRequestDelay().then(() => {
        // 简单验证旧密码是否正确
        if (data.old_password === 'admin' || data.old_password === 'admin123') {
          resolve(mockUpdatePasswordResponse)
        } else {
          resolve({
            code: 400,
            message: '旧密码错误'
          })
        }
      })
    })
  } else {
    // 实际请求后端API
    console.log('发送实际请求到/v1/auth/update-password')
    // 在请求前检查token是否存在
    const token = localStorage.getItem('access_token')
    console.log('localStorage中的token:', token)
    
    return request({
      url: '/v1/auth/update-password',
      method: 'post',
      data
    })
  }
}